import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { fetchCampusNewsDetail } from '../services/cms';
import RichText from '../components/news/RichText';

const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${y}년 ${Number(m)}월 ${Number(d)}일`;
};

export default function NewsDetailPage() {
  const { newsId } = useParams();
  const [state, setState] = useState({ status: 'loading', news: null });

  useEffect(() => {
    let alive = true;
    setState({ status: 'loading', news: null });
    fetchCampusNewsDetail(newsId)
      .then((news) => alive && setState({ status: 'ready', news }))
      .catch((e) =>
        alive && setState({ status: e?.response?.status === 404 ? 'notfound' : 'error', news: null })
      );
    return () => {
      alive = false;
    };
  }, [newsId]);

  const message =
    state.status === 'loading'
      ? '불러오는 중입니다…'
      : state.status === 'notfound'
      ? '없는 소식입니다.'
      : state.status === 'error'
      ? '소식을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'
      : null;

  return (
    <div className="bg-alternate min-h-[60vh] px-[20px] desktop:px-[50px] py-[40px] desktop:py-[80px]">
      <div className="max-w-[900px] mx-auto">
        <Link
          to="/news"
          className="kr-font inline-block mb-[20px] desktop:mb-[28px] text-secondary-text text-body-large hover:text-primary transition-colors"
        >
          ← 캠퍼스소식 목록
        </Link>

        <article className="bg-primary-background rounded-[24px] desktop:rounded-[40px] shadow-lg overflow-hidden">
          {message ? (
            <p className="kr-font text-center text-secondary-text text-body-large py-[80px] px-[24px]">{message}</p>
          ) : (
            <>
              {state.news.imageUrl && (
                <img
                  src={state.news.imageUrl}
                  alt={state.news.title}
                  className="w-full max-h-[460px] object-cover"
                />
              )}

              <div className="px-[24px] py-[32px] desktop:px-[60px] desktop:py-[50px]">
                <span className="kr-font text-secondary-text text-label-medium desktop:text-body-medium">
                  {formatDate(state.news.publishedAt)}
                </span>
                <h1 className="kr-font mt-[10px] text-primary-text font-semibold text-headline-small desktop:text-headline-large leading-snug break-keep">
                  {state.news.title}
                </h1>

                <div className="mt-[20px] desktop:mt-[32px] pt-[20px] desktop:pt-[32px] border-t border-custom2">
                  <RichText
                    content={state.news.content}
                    className="kr-font text-primary-text text-body-large desktop:text-title-medium"
                  />
                </div>
              </div>
            </>
          )}
        </article>

        <div className="mt-[28px] desktop:mt-[40px] text-center">
          <Link
            to="/inquiry"
            className="inline-block px-[40px] py-[15px] bg-primary rounded-lg text-primary-background text-title-small desktop:text-headline-small font-semibold font-inter hover:shadow-md transition-shadow"
          >
            입학문의
          </Link>
        </div>
      </div>
    </div>
  );
}
